import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FullPageLayout from "../../components/FullPageLayout";
import { Button, Box, Table, TableBody } from "@mui/material";
import {
  fetchAnnouncements,
  deleteAnnouncement,
  setAnnouncement
} from "../../redux/actions/announcementsActions";
import AnnouncementsListRow from "./AnnouncementsListRow";
import AnnouncementsListHead from "./AnnouncementsListHead";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import {
  root as learningCenterRoot,
  announcementsCreate as learningCenterAnnouncementsCreate
} from "../../routes/LearningCenterRoutes";
import { announcementsCreate as adminConsoleAnnouncementsCreate } from "../../routes/AdminRoutes";

function useAnnouncementsCreateRoute() {
  const location = useLocation();
  if (location.pathname.startsWith(learningCenterRoot)) {
    return learningCenterAnnouncementsCreate;
  } else {
    return adminConsoleAnnouncementsCreate;
  }
}

export default function AnnouncementsList() {
  const { t } = useTranslation();
  const history = useHistory();
  const announcementsCreate = useAnnouncementsCreateRoute();

  const dispatch = useDispatch();
  const user = useSelector(state => state.userState.user);
  const announcements = useSelector(
    state => state.announcementsState.announcements
  );

  const [selection, setSelection] = React.useState([]);
  const [expandedRow, setExpandedRow] = React.useState(0);

  React.useEffect(() => {
    dispatch(fetchAnnouncements("manage"));
  }, []);

  const gotoCreate = () => {
    dispatch(setAnnouncement());
    history.push(announcementsCreate);
  };

  const handleEditRow = rowData => ev => {
    ev.stopPropagation();
    dispatch(setAnnouncement(rowData));
    history.push(announcementsCreate);
  };

  const handleDeleteRow = rowData => ev => {
    ev.stopPropagation();
    dispatch(deleteAnnouncement(rowData));
  };

  const changeRowSelection = (id, isSelected = false) => {
    if (isSelected) {
      setSelection([...selection, id]);
    } else {
      setSelection(
        selection.filter(item => {
          return item !== id;
        })
      );
    }
  };

  const createButton = () => {
    return (
      <Box my={4} display="flex" justifyContent="flex-end">
        <Button color="primary" variant="contained" onClick={gotoCreate}>
          {t("announcements.options.create")}
        </Button>
      </Box>
    );
  };

  const handleExpandedRow = rowId => {
    setExpandedRow(rowId === expandedRow ? 0 : rowId);
  };

  return (
    <FullPageLayout
      title={
        <Box fontWeight="fontWeightRegular">
          {user.isAdmin
            ? t("announcements.options.manage")
            : t("announcements.title")}
        </Box>
      }
    >
      {user.isAdmin && createButton()}
      <Table data-qa="announcements-list">
        <AnnouncementsListHead adminView={user.isAdmin} />

        <TableBody>
          {announcements.map((row, idx) => (
            <AnnouncementsListRow
              key={idx}
              rowData={row}
              onExpand={handleExpandedRow}
              expanded={row.id === expandedRow}
              allowEdit={user.isAdmin}
              onCheckboxClick={changeRowSelection}
              onEditRowClick={handleEditRow}
              onDeleteRowClick={handleDeleteRow}
            />
          ))}
        </TableBody>
      </Table>
    </FullPageLayout>
  );
}
